/* @flow */
import * as React from 'react';

//----------------------------------------------------------------------//
// CSS.                                                                 //
//----------------------------------------------------------------------//

import styles from './ButtonGroup.module.scss';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

type TypeProps = {|
  children?: React.Node,
|};

function ButtonGroup(props: TypeProps) {
  const { children } = props;

  return <div className={styles['button-group']}>{children}</div>;
}

export default ButtonGroup;
